import { validationMessages } from './validationMessages.schema';

export default {
  title: 'Potwierdzenie hasła',
  type: 'object',
  properties: {
    password: {
      type: 'string',
      title: 'Hasło',
      fieldRequired: true,
      minLength: 8,
      validationMessages: {
        required: 'Błąd: Hasło jest wymagane.',
        minLength: 'Błąd: Minimalna długość hasła wynosi 8.'
      }
    },
    repeat: {
      type: 'string',
      title: 'Powtórz hasło',
      fieldRequired: true,
      validFunc: '$value && this.password ? $value === this.password : true',
      validationMessages: {
        required: 'Błąd: Powtórzenie hasła jest wymagane.',
        validFunc: 'Błąd: Oba hasła muszą być takie same.'
      }
    }
  },
  allOf: [validationMessages]
};
